export const CLOUD_NAME = 'dxbpmrjcp';
